// removed by extract-text-webpack-plugin
module.exports = {"component":"LWU2rDSmz54-JmVYH-mu5"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PersonalCenterDefault/PersonalCenterDefault.scss
 ** module id = 1088
 ** module chunks = 0
 **/